/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { RequestType } from '../types/request';
import { AxiosRequestConfig } from 'axios';

export function buildRequest({
  url,
  method,
  payload,
  isMultipart = false,
  timeout = 3000,
  headers = { 'Content-Type': 'application/json' },
}: RequestType) {
  const config: AxiosRequestConfig = {
    url,
    method,
    timeout,
    headers,
  };

  if (isMultipart && payload instanceof FormData) {
    config.headers!['Content-Type'] = 'multipart/form-data';
    config.data = payload || {};
  } else if (method === 'get') {
    config.params = payload || {};
  } else {
    config.data = payload;
  }

  return config;
}
